/** Rótulos e cores do sandbox do admin (backend `src/modules/sandbox`). */

export const ENTITY_LABELS: Record<Sandbox.EntityType, string> = {
	USER: 'Usuários',
	PROFESSIONAL: 'Profissionais',
	SUBSCRIPTION: 'Assinaturas',
	SESSION: 'Sessões',
	COMPANY: 'Empresas',
	EMPLOYEE: 'Colaboradores',
	MATCH_ANSWER: 'Respostas do match',
};

export const ENTITY_ORDER: Sandbox.EntityType[] = [
	'USER',
	'PROFESSIONAL',
	'SUBSCRIPTION',
	'SESSION',
	'COMPANY',
	'EMPLOYEE',
	'MATCH_ANSWER',
];

export const ACTOR_LABELS: Record<Sandbox.Actor, string> = {
	ADMIN: 'Admin',
	USER: 'Usuário',
	PROFESSIONAL: 'Profissional',
	SYSTEM: 'Sistema',
};

/** Cor do ator na linha do tempo: quem "fez" a ação simulada. */
export const ACTOR_CLASSES: Record<Sandbox.Actor, string> = {
	ADMIN: 'bg-stone-900 text-white',
	USER: 'bg-brand-pink/10 text-brand-pink',
	PROFESSIONAL: 'bg-brand-orange/10 text-brand-orange',
	SYSTEM: 'bg-stone-100 text-stone-500',
};

export const SESSION_STATUS_LABELS: Record<
	Sandbox.ScenarioSession['status'],
	string
> = {
	WAITING_CONFIRMATION: 'Aguardando confirmação',
	CREATED: 'Aguardando pagamento',
	CONFIRMED: 'Confirmada',
	STARTED: 'Em andamento',
	FINISHED: 'Finalizada',
	CANCELLED: 'Cancelada',
};

export const SESSION_STATUS_CLASSES: Record<
	Sandbox.ScenarioSession['status'],
	string
> = {
	WAITING_CONFIRMATION: 'bg-amber-50 text-amber-700',
	CREATED: 'bg-amber-50 text-amber-700',
	CONFIRMED: 'bg-emerald-50 text-emerald-700',
	STARTED: 'bg-sky-50 text-sky-700',
	FINISHED: 'bg-stone-900 text-white',
	CANCELLED: 'bg-rose-50 text-rose-700',
};

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
	WAITING: 'aguardando',
	DONE: 'pago',
	FAILED: 'falhou',
	REFUNDED: 'reembolsado',
	EXPIRED: 'expirado',
};

export const SUBSCRIPTION_STATUS_LABELS: Record<string, string> = {
	PENDING: 'Pendente',
	ACTIVE: 'Ativa',
	CANCELLED: 'Cancelada',
	EXPIRED: 'Expirada',
	SUSPENDED: 'Suspensa',
};

export const SUBSCRIPTION_STATUS_CLASSES: Record<string, string> = {
	PENDING: 'bg-amber-50 text-amber-700',
	ACTIVE: 'bg-emerald-50 text-emerald-700',
	CANCELLED: 'bg-rose-50 text-rose-700',
	EXPIRED: 'bg-stone-100 text-stone-500',
	SUSPENDED: 'bg-stone-100 text-stone-500',
};

export const JOURNEYS: Array<{
	key: Sandbox.Journey;
	label: string;
	description: string;
}> = [
	{
		key: 'B2C_SUBSCRIPTION',
		label: 'Assinante B2C',
		description:
			'Cadastro do usuário → profissional com agenda → assinatura do plano (pagamento simulado) → questionário do match → sessão paga com o benefício → início → fim.',
	},
	{
		key: 'B2C_SINGLE_SESSION',
		label: 'Sessão avulsa',
		description:
			'Cadastro do usuário → profissional com agenda → sessão avulsa com pagamento manual confirmado → início → fim.',
	},
];

export const CANCEL_ACTOR_LABELS: Record<Sandbox.CancelActor, string> = {
	USER: 'como usuário',
	PROFESSIONAL: 'como profissional',
	ADMIN: 'como admin',
};

const dateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
	timeZone: 'America/Sao_Paulo',
	day: '2-digit',
	month: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
});

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
	timeZone: 'America/Sao_Paulo',
	day: '2-digit',
	month: '2-digit',
	year: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('pt-BR', {
	timeZone: 'America/Sao_Paulo',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit',
});

export const formatDateTime = (value?: string | null) =>
	value ? dateTimeFormatter.format(new Date(value)) : '—';

export const formatDate = (value?: string | null) =>
	value ? dateFormatter.format(new Date(value)) : '—';

export const formatTime = (value?: string | null) =>
	value ? timeFormatter.format(new Date(value)) : '—';

export const formatMoney = (value: number) =>
	value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const fullName = (person: {
	first_name: string;
	last_name?: string | null;
	name_prefix?: string | null;
}) =>
	[person.name_prefix, person.first_name, person.last_name]
		.filter(Boolean)
		.join(' ');
